import { apiSlice } from "../../app/api/apiSlice";

export const applicationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createLoan: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/user/create_loan/",
				method: "POST",
				body: credentials,
			}),
		}),
	}),
});

export const { useCreateLoanMutation } = applicationApiSlice;
